module.exports = __webpack_public_path__ + "static/media/icon-boards.b4e89e5a.svg";